import moment from "moment";
import { isDineInEnabled, getAttributeValue } from "@/utils";

export const ORDER_MODE = [
  { value: "DINE_IN", display: "Dine In", enabled: isDineInEnabled },
  { value: "PICK_UP", display: "Take Away", enabled: true },
  { value: "TAKEAWAY", display: "Delivery", enabled: true },
];

export function isDelivery(orderModeString) {
  return "TAKEAWAY" === orderModeString;
}

export function isDineIn(orderModeString) {
  return "DINE_IN" === orderModeString;
}

export const ORDER_STATUS = [
  { value: "CREATED", display: "Created", styleClazz: "bg-black gold" },
  {
    value: "WAIT_FOR_PAYMENT",
    display: "Wait For Payment",
    styleClazz: "bg-red gold",
  },
  {
    value: "PAYMENT_CONFIRMED",
    display: "Payment Confirmed",
    styleClazz: "bg-gold black border-black border-solid",
  },
  {
    value: "IN_KITCHEN",
    display: "In Kitchen",
    styleClazz: "bg-gold black border-black border-solid",
  },
  {
    value: "COMPLETED",
    display: "Completed",
    styleClazz: "bg-gold black border-black border-solid",
  },
  {
    value: "CANCELLED",
    display: "Cancelled",
    styleClazz: "bg-gold gray border-gray border-solid",
  },
];

export const ORDER_PAYMENT_METHOD = [
  {
    value: "EFT",
    display: "Bank Transfer",
    supportedMode: ["PICK_UP", "TAKEAWAY", "DINE_IN"],
  },
  { value: "CASH_OR_CARD", display: "Cash", supportedMode: ["PICK_UP"] },
  {
    value: "CREDIT_CARD",
    display: "Card",
    supportedMode: ["PICK_UP", "TAKEAWAY", "DINE_IN"],
  },
  {
    value: "PAY_AT_COUNTER",
    display: "Pay At Counter",
    supportedMode: ["DINE_IN"],
    hidden: true,
  },
  {
    value: "ALIPAY",
    display: "Alipay",
    supportedMode: ["PICK_UP", "TAKEAWAY", "DINE_IN"],
  },
];

export const LINE_ITEM_STATUS = {
  CREATED: {
    value: "CREATED",
    display: "Created",
  },
  IN_KITCHEN: {
    value: "IN_KITCHEN",
    display: "In Kitchen",
  },
  COMPLETED: {
    value: "COMPLETED",
    display: "Completed",
  },
  CANCELLED: {
    value: "CANCELLED",
    display: "Cancelled",
  },
};

export function getOrderAvailableDates(numberOfDays) {
  return Array.from(Array(numberOfDays).keys()).map((d) =>
    moment()
      .startOf("day")
      .add(d, "day")
      .format("ddd D MMM YYYY")
  );
}

export const TIME_SLOT = {
  PICK_UP: [
    "10:30am-10:45am",
    "10:45am-11:00am",
    "11:00am-11:15am",
    "11:15am-11:30am",
    "11:30am-11:45am",
    "11:45am-12:00pm",
    "12:00pm-12:15pm",
    "12:15pm-12:30pm",
    "12:30pm-12:45pm",
    "12:45pm-1:00pm",
    "1:00pm-1:15pm",
    "1:15pm-1:30pm",
    "1:30pm-1:45pm",
    "1:45pm-2:00pm",
    "2:00pm-2:15pm",
    "2:15pm-2:30pm",
    "2:30pm-2:45pm",
    "2:45pm-3:00pm",
    "4:30pm-4:45pm",
    "4:45pm-5:00pm",
    "5:00pm-5:15pm",
    "5:15pm-5:30pm",
    "5:30pm-5:45pm",
    "5:45pm-6:00pm",
    "6:00pm-6:15pm",
    "6:15pm-6:30pm",
    "6:30pm-6:45pm",
    "6:45pm-7:00pm",
    "7:00pm-7:15pm",
    "7:15pm-7:30pm",
    "7:30pm-7:45pm",
    "7:45pm-8:00pm",
    "8:00pm-8:15pm",
    "8:15pm-8:30pm",
  ],
  TAKEAWAY: [
    // delivery
    "11:00am-11:30am",
    "11:30am-12:00pm",
    "12:00pm-12:30pm",
    "12:30pm-1:00pm",
    "1:00pm-1:30pm",
    "1:30pm-2:00pm",
    "2:00pm-2:30pm",
    "5:00pm-5:30pm",
    "5:30pm-6:00pm",
    "6:00pm-6:30pm",
    "6:30pm-7:00pm",
    "7:00pm-7:30pm",
    "7:30pm-8:00pm",
    "8:00pm-8:30pm",
  ],
  DELIVERY_WEEKEND: [
    "10:30am-11:00am",
    "11:00am-11:30am",
    "11:30am-12:00pm",
    "12:00pm-12:30pm",
    "12:30pm-1:00pm",
    "1:00pm-1:30pm",
    "1:30pm-2:00pm",
    "2:00pm-2:30pm",
    "5:00pm-5:30pm",
    "5:30pm-6:00pm",
    "6:00pm-6:30pm",
    "6:30pm-7:00pm",
    "7:00pm-7:30pm",
    "7:30pm-8:00pm",
    "8:00pm-8:30pm",
    "8:30pm-9:00pm",
  ],
};

export const MINIMUM_DELIVERY_AMOUNT = 150;
export const MINIMUM_DELIVERY_AMOUNT_MATRIX = [
  {
    distance: {
      min: 0,
      max: 10000,
    },
    minimumAmount: MINIMUM_DELIVERY_AMOUNT,
  },
  {
    distance: {
      min: 10001,
      max: Number.MAX_SAFE_INTEGER,
    },
    minimumAmount: 200,
  },
];
export const FREE_DELIVERY_MAX_DISTANCE = "5km";
export const UNIT_DELIVERY_FEE = "$1";

export function calculateSurcharge(
  subtotal,
  discountAmount,
  deliveryAmount,
  surchargePercent
) {
  return (
    (Number(subtotal) - Number(discountAmount) + Number(deliveryAmount)) *
    surchargePercent
  );
}

export function calculateTotalAmount(
  subtotal,
  paymentSurcharge,
  discountAmount,
  deliveryAmount
) {
  return (
    Number(subtotal) +
    Number(paymentSurcharge) -
    Number(discountAmount) +
    Number(deliveryAmount)
  );
}

export function hasEventProduct(lineItems) {
  return !!lineItems.find(
    (item) => !!getAttributeValue(item.attributes, "isEventProduct")
  );
}

export function getEventProduct(lineItems) {
  return lineItems.find(
    (item) => !!getAttributeValue(item.attributes, "isEventProduct")
  );
}
